<script setup lang="ts">
import IconSchedule from '~icons/material-symbols/schedule-outline'
import IconWarning from '~icons/material-symbols/warning-outline'
import date from '~/utils/date'
import { type FinancingListItem, GeneralStatuses } from '~/utils/financing-flow/Financing'

interface Props {
  item: FinancingListItem
}

const props = defineProps<Props>()
const { t } = useI18n()

const daysUntilExpiration = computed(() => {
  const { item } = props
  if (!item.expires_at) return 0

  const expirationDate = date(item.expires_at)
  const currentDate = date()
  return expirationDate.diff(currentDate, 'days')
})

const expiredText = computed(() => {
  const { item } = props

  if (!item.expires_at) return '-'

  const expirationDate = date(item.expires_at)
  const currentDate = date()
  const daysUntilExp = expirationDate.diff(currentDate, 'days')

  const shouldShowDashLogic = item.is_expired
    || item.status === GeneralStatuses.EXPIRED
    || item.status === GeneralStatuses.CANCELED
    || item.status === GeneralStatuses.REPROVED
    || daysUntilExp > 15
    || daysUntilExp < 0

  return shouldShowDashLogic ? '-' : expirationDate.fromNow(true)
})

const shouldShowDash = computed(() => expiredText.value === '-')
</script>

<template>
  <div>
    <p class="fonts-body-small-regular text-neutral-low-light">
      {{ t('financing.list.headers.deadline_for_formalization') }}
    </p>
    <p class="fonts-body-medium-regular flex gap-1">
      <template v-if="shouldShowDash">
        {{ expiredText }}
      </template>
      <template v-else>
        <IconSchedule
          v-if="daysUntilExpiration > 10"
          class="text-brand-secondary-pure"
        />
        <IconWarning
          v-else-if="daysUntilExpiration <= 5"
          class="text-feedback-negative-pure"
        />
        <span
          :class="{
            'text-feedback-negative-pure': daysUntilExpiration <= 5,
          }"
        >
          {{ expiredText }}
        </span>
      </template>
    </p>
  </div>
</template>
